import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Outlet, Navigate } from 'react-router-dom';
import Unauthorized from '../Unauthorized';
import { UserContext } from '../../../context/UserContext';

/**
 * Dashboard component to control access based on user roles and authentication status.
 *
 * @param {Object} props - Component properties.
 * @param {Array} [props.hasOneOfRequiredRoles] - Array of roles; user must have at least one.
 * @param {Array} [props.hasAllOfRequiredRoles] - Array of roles; user must have all.
 *
 * @returns {JSX.Element} The Dashboard component.
 */
const Dashboard = ({ hasOneOfRequiredRoles,
                     hasAllOfRequiredRoles}) => {
  const { user } = useContext(UserContext);

  const userRoles = user.roles || [];

  const hasOneOfRoles = hasOneOfRequiredRoles
      ? hasOneOfRequiredRoles.some(role => userRoles.includes(role))
      : true;

  const hasAllOfRoles = hasAllOfRequiredRoles
      ? hasAllOfRequiredRoles.every(role => userRoles.includes(role))
      : true;

  if (!hasOneOfRoles || !hasAllOfRoles) {
    return <Unauthorized />;
  }

  return <Outlet />;
};

Dashboard.propTypes = {
  hasOneOfRequiredRoles: PropTypes.arrayOf(PropTypes.string),
  hasAllOfRequiredRoles: PropTypes.arrayOf(PropTypes.string),
};

Dashboard.defaultProps = {
  hasOneOfRequiredRoles: null,
  hasAllOfRequiredRoles: null,
};

export default Dashboard;
